module.exports = __webpack_public_path__ + "static/media/wmsui32_5086.b9988929.ico";